import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export function LabeledInfo({ label, children, prominent = false, color = "text.primary" }: {
  label: string; children: ReactNode; prominent?: boolean; color?: string;
}) {
  return (
    <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
      <Typography component="div" variant="caption" color="text.secondary">{label}</Typography>
      <Box sx={{ typography: prominent ? "body1" : "body2", fontWeight: prominent ? 850 : 650, color }}>
        {children}
      </Box>
    </Box>
  );
}

